export default __webpack_public_path__ + "static/media/layers.88343093.svg";